module.exports = "/_next/static/images/admin-login-image-d85f157245b2a905d32ae56736120755.png";